<div *ngIf="order" class="ms-3 mobile-mg-0">
  <div class="col-xxl-12 col-lg-12 col-md-12 col-sm-12 d-grid gap-3 bg-white p-4 rounded-3 mobile-pd d-flex">
    <div class="col-12">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center gap-2">
          <h3>Đơn Hàng {{ order.orderId }}</h3>
          <img src="assets/svg/copy-1.svg" alt="Copy orderId" style="cursor: pointer;"
            (click)="copyToClipboard(order.orderId)"  loading="lazy" />
        </div>
        <div class="d-none d-md-flex d-lg-flex d-xl-flex d-xxl-flex align-items-center gap-3">
          <button type="button" class="btn btn-sm" style="background-color: white; color: var(--theme-color); border: 1px solid var(--theme-color);" (click)="orderHistoryModal.openModal()">
            <img src="assets/svg/order/time-past.svg"  loading="lazy" />&nbsp;{{'Lịch sử trạng thái' | translate}}
          </button>
          <button *ngIf="canReOrder" type="button" class="btn btn-sm" style="background-color: var(--theme-color); color: white;" (click)="reOrder()" data-cta="order.reorder" data-cta-loc="order_detail">
            <img src="assets/svg/order/shopping-basket.svg"  loading="lazy" />&nbsp;{{'Đặt hàng lại' | translate}}
          </button>
        </div>
      </div>
      <div class="d-flex align-items-center w-100 d-none d-xl-flex d-lg-flex pt-3">
        <div class="col-4 text-gray d-grid gap-2">
          <h5>Ngày mua</h5>
          <h5>Trạng thái đơn hàng</h5>
        </div>
        <div class="col-8 d-grid gap-2">
          <h5>{{order.orderDate | date: 'HH:mm:ss EEEE (dd/MM/yyyy)':undefined:'vi'}}</h5>
          <span class="d-flex align-items-center gap-1">
            <ng-container *ngTemplateOutlet="
                template;
                context: { status: getOrderStatus(order.orderStatus) }
              "></ng-container>
            <ng-template #template let-status="status">
              <span class="dot {{
                  status.icon
                }} d-flex align-items-center justify-content-center"><span
                  class="inner-dot {{ status.icon }}"></span></span>
              <h5 class="{{ status.icon }}">{{ status.value }}</h5>
            </ng-template>
          </span>
        </div>
      </div>
      <div class="d-lg-none d-xl-none">
        <div class="d-flex align-items-center gap-3" style="padding: 10px 0 16px;">
          <button type="button" class="btn btn-sm" style="background-color: white; color: var(--theme-color); border: 1px solid var(--theme-color);" (click)="orderHistoryModal.openModal()">
            <img class="mobile" src="assets/svg/order/time-past.svg"  loading="lazy" />&nbsp;{{'Lịch sử trạng thái' | translate}}
          </button>
          <button *ngIf="canReOrder" type="button" class="btn btn-sm" style="background-color: var(--theme-color); color: white;" (click)="reOrder()" data-cta="order.reorder" data-cta-loc="order_detail">
            <img class="mobile" src="assets/svg/order/shopping-basket.svg"  loading="lazy" />&nbsp;{{'Đặt hàng lại' | translate}}
          </button>
        </div>
        <div class="d-flex w-100 gap-2">
          <h5 class="text-gray">Ngày mua:</h5>
          <h5>{{order.orderDate | date: 'HH:mm:ss EEEE (dd/MM/yyyy)':undefined:'vi'}}</h5>
        </div>
        <div class="d-flex w-100 gap-2">
          <h5 class="text-gray">Trạng thái đơn hàng:</h5>
          <span class="d-flex align-items-center gap-1">
            <ng-container *ngTemplateOutlet="
                template;
                context: { status: getOrderStatus(order.orderStatus) }
              "></ng-container>
            <ng-template #template let-status="status">
              <span class="dot {{
                  status.icon
                }} d-flex align-items-center justify-content-center"><span
                  class="inner-dot {{ status.icon }}"></span></span>
              <h5 class="{{ status.icon }}">{{ status.value }}</h5>
            </ng-template>
          </span>
        </div>
      </div>
      <div class="col-12 pt-3">
        <h5 class="text-gray">Địa Chỉ Và Thông Tin Người Nhận Hàng</h5>
        <ul class="ps-4 pt-3 d-grid gap-2">
          <li>
            <h5>Tên Người Nhận: {{ order.receiverInfo.userName }}</h5>
          </li>
          <li>
            <h5>Địa Chỉ Giao Hàng: {{ order.receiverInfo.address }}</h5>
          </li>
          <li>
            <h5>Số Điện Thoại: {{ order.receiverInfo.phone }}</h5>
          </li>
          <li>
            <h5>
              Email:
              <span *ngIf="order.receiverInfo.email; else noEmail">
                {{ order.receiverInfo.email }}
              </span>
              <ng-template #noEmail> (Chưa có) </ng-template>
            </h5>
          </li>
        </ul>
      </div>
      <div class="col-12 pt-3" *ngIf="order.orderShipping?.length">
        <h5 class="text-gray">Thông tin giao hàng</h5>
        <ul class="ps-4 pt-3 d-grid gap-2">
          <ng-container *ngFor="let shipping of order.orderShipping; let last = last; let i = index">
            <li>
              <h5>Mã giao vận: {{ shipping.trackingNumber }}</h5>
            </li>
            <li>
              <h5>Đơn vị giao hàng: {{ shipping.transportCompany }}</h5>
            </li>
            <li>
              <h5>Thời gian giao hàng dự kiến: {{ shipping.estimatedDeliveryTime }}</h5>
            </li>
            <li>
              <h5 class="d-flex align-items-center gap-2">
                <span>Lịch sử giao hàng: </span>
                <button type="button" class="btn btn-sm btn-link p-0"
                  (click)="orderShippingStatus(shipping.trackingUrl, shipping.trackingNumber)" data-cta="order.track_shipping" data-cta-loc="order_detail"
                  style="color: var(--theme-color);">
                  <i class="ri-information-line"></i>&nbsp;{{ 'Chi tiết' | translate }}
                </button>
              </h5>
            </li>
            <!--            <li>-->
            <!--              <h5>-->
            <!--                Phí vận chuyển:-->
            <!--                <span *ngIf="shipping.cost; else freeShippingCost">-->
            <!--            {{ shipping.cost }}-->
            <!--          </span>-->
            <!--                <ng-template #freeShippingCost> Miễn phí vận chuyển </ng-template>-->
            <!--              </h5>-->
            <!--            </li>-->
            <hr [ngClass]="last ? 'solid-divider' : 'dashed-divider'" />
          </ng-container>
        </ul>
      </div>

      <div class="d-flex align-items-center w-100 d-none d-xl-flex d-lg-flex pt-3">
        <div class="col-4 text-gray d-grid gap-2">
          <h5>Hình Thức Thanh Toán:</h5>
          <h5>Ghi chú:</h5>
        </div>
        <div class="col-8 d-grid gap-2">
          <h5>
            <span *ngIf="order.paymentMethod; else noPaymentMethod">
              {{ order.paymentMethod}}
            </span>
            <ng-template #noPaymentMethod> Chuyển khoản ngân hàng </ng-template>
          </h5>
          <h5>
            <span *ngIf="order.note; else noNote">
              {{ order.note }}
            </span>
            <ng-template #noNote> Không có </ng-template>
          </h5>
        </div>
      </div>
      <div class="d-flex align-items-center w-100 d-none d-xl-flex d-lg-flex pt-2">
        <div class="col-4 text-gray d-grid gap-2">
          <h5>Trạng thái thanh toán:</h5>
        </div>
        <div class="col-8 d-grid gap-2">
          <span class="d-flex align-items-center gap-1">
            <ng-container *ngTemplateOutlet="
              paymentStatusTemplate;
              context: { status: getPaymentStatus(order.paymentStatus) }
            ">
            </ng-container>
            <ng-template #paymentStatusTemplate let-status="status">
              <span class="dot {{ status.icon }} d-flex align-items-center justify-content-center">
                <span class="inner-dot {{ status.icon }}"></span>
              </span>
              <h5 class="{{ status.icon }}">{{ status.value }}</h5>
            </ng-template>
          </span>
        </div>
      </div>
      <div class="d-flex align-items-center w-100 d-none d-xl-flex d-lg-flex pt-2" *ngIf="order.invoices">
        <div class="col-4 text-gray d-grid gap-2">
          <h5>Hóa đơn điện tử:</h5>
        </div>
        <div class="col-8 d-flex gap-2">
          <ng-container *ngFor="let inv of order.invoices">
            <a href="javascript:void(0)" (click)="getOrderInvoice(inv.invoiceCode)" data-cta="order.invoice" data-cta-loc="order_detail"
              [class.disabled]="isGettingInvoice[inv.invoiceCode]" rel="noopener noreferrer">
              <span type="button" class="d-flex align-items-center gap-2" style="color: #0c4128">
                <i class="ri-eye-line"></i>
                <span>Xem hóa đơn</span>
              </span>
            </a>
          </ng-container>
        </div>
      </div>
      <div class="d-lg-none d-xl-none">
        <div class="d-flex w-100 gap-2">
          <h5 class="text-gray">Hình Thức Thanh Toán:</h5>
          <h5>
            <span *ngIf="order.paymentMethod; else noPaymentMethod">
              {{ order.paymentMethod}}
            </span>
            <ng-template #noPaymentMethod> Chuyển khoản ngân hàng </ng-template>
          </h5>
        </div>
        <div class="d-flex w-100 gap-2">
          <h5 class="text-gray">Ghi chú:</h5>
          <h5>
            <span *ngIf="order.note; else noNote">
              {{ order.note }}
            </span>
            <ng-template #noNote> Không có </ng-template>
          </h5>
        </div>
        <div class="d-flex w-100 gap-2" *ngIf="order.paymentStatus != null">
          <h5 class="text-gray">Trạng thái thanh toán:</h5>
          <span class="d-flex align-items-center gap-1">
            <ng-container *ngTemplateOutlet="
              paymentStatusTemplate;
              context: { status: getPaymentStatus(order.paymentStatus) }
            ">
            </ng-container>
            <ng-template #paymentStatusTemplate let-status="status">
              <span class="dot {{ status.icon }} d-flex align-items-center justify-content-center">
                <span class="inner-dot {{ status.icon }}"></span>
              </span>
              <h5 class="{{ status.icon }}">{{ status.value }}</h5>
            </ng-template>
          </span>
        </div>
        <div class="d-flex w-100 gap-2" *ngIf="order.invoices">
          <h5 class="text-gray">Hóa đơn điện tử:</h5>
          <ng-container *ngFor="let inv of order.invoices">
            <a href="javascript:void(0)" (click)="getOrderInvoice(inv.invoiceCode)" data-cta="order.invoice" data-cta-loc="order_detail"
              [class.disabled]="isGettingInvoice[inv.invoiceCode]" rel="noopener noreferrer"
              class="d-flex align-items-center gap-2">
              <button type="button" class="btn btn-sm btn-info d-flex align-items-center gap-1">
                <i class="ri-file-download-line"></i>
                <span>Xem hóa đơn</span>
              </button>
            </a>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <section>
    <div class="bg-white p-4 rounded-3 mobile-pd">
      <div class="col-xxl-5 col-lg-5 col-md-5 col-sm-5 d-grid gap-3 bg-white p-4 rounded-3 mobile-pd d-flex"
        style="margin-bottom: 15px;"
        *ngIf="order.orderStatus !== cancelledOrderStatus && order.orderStatus !== paidOrderStatus && order.paymentMethod">
        <div style="width: 70%;">
          <app-qr-code [qrImgSrc]="qrImgSrc"></app-qr-code>
          <div class="pt-3 reorder-container">
            <button class="btn btn-sm btn-success d-flex align-items-center text-start gap-2 px-2 py-1 border-0"
              style="border-radius: 5px; white-space: wrap;" (click)="downloadQRCode()">
              <img src="assets/svg/download_qr_white.svg" alt="download QR" style="width: 23px; height: 23px;"
                class="justify-content-center"  loading="lazy" />
              <h6 class="text-white">Tải xuống</h6>
            </button>
          </div>
        </div>
      </div>

      <ng-container *ngIf="missingProducts?.length">
        <div class="row">
          <div class="col-md-8 col-xs-12 fs-4 my-auto">Danh Sách Sản Phẩm Giao Thiếu ({{ missingProducts.length }} Sản Phẩm)</div>
        </div>
        <div class="card ps-0 pe-0">
          <div class="card-body">
            <div class="tracking-wrapper table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th *ngFor="let col of headerColumnsForMisingProducts" scope="col" class="d-none d-xl-table-cell d-lg-table-cell">
                      {{ col }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of missingProducts; let i = index">
                    <td class="d-none d-xl-table-cell d-lg-table-cell">
                      <h6>{{ i + 1 }}</h6>
                    </td>
                    <td class="col-xxl-6 col-lg-7 col-md-7 col-sm-7 product-image">
                      <div class="d-flex align-items-center gap-3">
                        <div class="d-grid gap-2">
                          <h6 class="fw-bold text-black">{{ item.productName }}</h6>
                          <div class="d-lg-none d-xl-none d-grid gap-2">
                            <h6><span class="text-gray">Số lượng giao thiếu: </span>{{ item.quantity }}</h6>
                            <h6><span class="text-gray">Giá: </span>{{ item.price | currencySymbol }}</h6>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="d-none d-xl-table-cell d-lg-table-cell">
                      <h6>{{ item.quantity }}</h6>
                    </td>
                    <td class="d-none d-xl-table-cell d-lg-table-cell">
                      <h6>{{ item.price | currencySymbol }}</h6>
                    </td>
                    <td class="d-none d-xl-table-cell d-lg-table-cell">
                      <h6>{{ item.totalPrice | currencySymbol }}</h6>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="order.giftItems.length">
        <div class="row">
          <div class="col-md-8 col-xs-12 fs-4 my-auto">Danh Sách Quà ({{ order.giftItems.length }} Quà)</div>
        </div>
        <div class="card ps-0 pe-0">
          <div class="card-body">
            <div class="tracking-wrapper table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th class="col-xxl-6 col-lg-7 col-md-7 col-sm-7">Quà</th>
                    <th class="d-none d-xl-table-cell d-lg-table-cell">Số lượng</th>
                    <th class="d-none d-xl-table-cell d-lg-table-cell">Thành tiền (đ)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let giftItem of order.giftItems">
                    <td class="col-xxl-6 col-lg-7 col-md-7 col-sm-7">
                      <div class="d-flex align-items-center gap-3">
                        <img style="width: 4rem" [src]="
                            giftItem.imageUrls
                              ? giftItem.imageUrls[0]
                              : 'assets/images/product.png'
                          " class="img-fluid" alt="gift"  loading="lazy" />
                        <div class="d-grid gap-2">
                          <h6 class="fw-bold text-black">{{ giftItem.name }}</h6>
                          <div class="d-lg-none d-xl-none d-grid gap-2">
                            <h6><span class="text-gray">Số lượng: </span>{{ giftItem.quantity }}</h6>
                            <h6><span class="text-gray">Thành tiền (đ): </span>{{ giftItem.cost | currencySymbol }}</h6>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="d-none d-xl-table-cell d-lg-table-cell">
                      <h6 class="text-black">{{ giftItem.quantity }}</h6>
                    </td>
                    <td class="d-none d-xl-table-cell d-lg-table-cell">
                      <h6 class="text-black">{{ giftItem.cost | currencySymbol }}</h6>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="order.items.length">
        <div class="row">
          <div class="col-md-8 col-xs-12 fs-4 my-auto">Danh Sách Sản Phẩm ({{ order.items.length }} Sản Phẩm)</div>
          <div class="col-md-4 col-xs-12 reorder-container">
            <div class="d-flex flex-row-reverse gap-2">
              <button type="button" class="btn btn-sm btn-warning"
                *ngIf="isReadyReturnOrder && ((returnOrders?.length ?? 0) === 0)" (click)="returnOrder()" data-cta="order.return" data-cta-loc="order_detail">
                <i class="ri-send-plane-line"></i>&nbsp;{{ 'Trả hàng' | translate }}
              </button>
              <button type="button" class="btn btn-sm btn-link" *ngIf="returnOrders?.length"
                (click)="viewReturnOrderList()">
                <i class="ri-list-check-2"></i>&nbsp;{{ 'Phiếu trả hàng' | translate }}
              </button>
              <button type="button" class="btn btn-sm btn-link" *ngIf="order.shipments?.length"
                (click)="viewShipmentList()">
                <i class="ri-list-check-2"></i>&nbsp;{{ 'Phiếu xuất kho' | translate }}
              </button>
            </div>
          </div>
        </div>
        <div class="card ps-0 pe-0">
          <div class="card-body">
            <div class="tracking-wrapper table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th *ngFor="let col of headerColumns" scope="col" class="d-none d-xl-table-cell d-lg-table-cell">
                      {{ col }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of order.items">
                    <td class="col-xxl-6 col-lg-7 col-md-7 col-sm-7 product-image">
                      <div class="d-flex align-items-center gap-3">
                        <img style="width: 4rem" [src]="
                              item.imgUrl
                                ? item.imgUrl
                                : 'assets/images/product.png'
                            " class="img-fluid" alt="product"  loading="lazy" />
                        <div class="d-grid gap-2">
                          <div *ngIf="item.expirationDate && item.expirationDate.trim()" class="expired">
                            <span>Date {{ item.expirationDate | date:'dd/MM/yyyy':'UTC' }}</span>
                          </div>
                          <a [routerLink]="['/product/', item.slug ]" class="link">
                            <h6 class="fw-bold text-black">{{ item.name }}</h6>
                          </a>
                          <div class="d-lg-none d-xl-none d-grid gap-2">
                            <h6><span class="text-gray">Số lượng khách đặt: </span>{{ item.actualQuantity }}</h6>
                            <h6><span class="text-gray">Số lượng giao thực tế: </span>{{ item.quantity }}</h6>
                            <h6><span class="text-gray">Đơn giá (đ): </span>{{ item.price }}</h6>
                            <h6><span class="text-gray">Thành tiền (đ): </span>{{ item.totalPrice | currencySymbol }}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="d-none d-xl-table-cell d-lg-table-cell">
                      <h6>{{ item.actualQuantity }}</h6>
                    </td>
                    <td class="d-none d-xl-table-cell d-lg-table-cell">
                      <h6>{{ item.quantity }}</h6>
                    </td>
                    <td class="d-none d-xl-table-cell d-lg-table-cell">
                      <h6>{{ item.price | currencySymbol }}</h6>
                    </td>
                    <td class="d-none d-xl-table-cell d-lg-table-cell">
                      <h6>{{ item.totalPrice | currencySymbol }}</h6>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="card ps-0 pe-0 mt-3" *ngIf="order.giftExchange?.length">
        <div class="card-body">
          <h5 class="fw-bold mb-3">Quà trong đơn hàng</h5>
          <div class="tracking-wrapper table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th class="col-xxl-6 col-lg-7 col-md-7 col-sm-7">Tên</th>
                  <th class="d-none d-xl-table-cell d-lg-table-cell">Điểm / đơn vị</th>
                  <th class="d-none d-xl-table-cell d-lg-table-cell">Số lượng</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let gift of order.giftExchange">
                  <td class="col-xxl-6 col-lg-7 col-md-7 col-sm-7">
                    <div class="d-flex align-items-center gap-3">
                      <div class="d-grid gap-2">
                        <h6 class="fw-bold text-black">{{ gift.name }}</h6>
                        <div class="d-lg-none d-xl-none d-grid gap-2">
                          <h6><span class="text-gray">Điểm / đơn vị: </span>{{ gift.poinPerUnit }}</h6>
                          <h6><span class="text-gray">Số lượng: </span>{{ gift.quantity }}</h6>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="d-none d-xl-table-cell d-lg-table-cell">{{ gift.poinPerUnit }}</td>
                  <td class="d-none d-xl-table-cell d-lg-table-cell">{{ gift.quantity }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="col-xxl-12 col-lg-12 col-md-12 col-sm-12 d-flex justify-content-end text-end mobile-detail-bottom">
        <div class="col-5 d-grid gap-3 mobile-w-100">
          <div class="d-flex align-items-center w-100">
            <div class="col-6 text-gray d-grid gap-4 text-start">
              <h5 class="fw-bold">Tạm Tính</h5>
            </div>
            <div class="col-6 d-grid gap-4">
              <h5>
                {{ order.sumTotalPrice | currencySymbol }}
              </h5>
            </div>
          </div>
          <div class="d-flex align-items-center w-100">
            <div class="col-8 text-gray d-grid gap-4 text-start">
              <span class="d-flex align-items-center gap-4">
                <h5 class="fw-bold">Giá giảm voucher</h5>
                <span *ngIf="order.appliedVoucher" style="color: var(--theme-color)">{{
                  order.appliedVoucher.code
                  }}</span>
              </span>
            </div>
            <div class="col-4 gap-4">
              <h5>
                <span *ngIf="order.voucherDiscountAmount; else noVoucher">
                  - {{ order.voucherDiscountAmount | currencySymbol }}
                </span>
                <ng-template #noVoucher> Không có </ng-template>
              </h5>
            </div>
          </div>
          <div *ngIf="order.appliedCoin" class="d-flex align-items-center w-100">
            <div class="col-8 text-gray d-grid gap-4 text-start">
              <span class="d-flex align-items-center gap-4">
                <h5 class="fw-bold">Giá giảm xu</h5>
              </span>
            </div>
            <div class="col-4 gap-4">
              <h5>
                <span *ngIf="order.appliedCoin; else noCoin" style="color: var(--theme-color)">
                  - {{ order.appliedCoin | currencySymbol }}
                </span>
                <ng-template #noCoin> Không có </ng-template>
              </h5>
            </div>
          </div>
          <div class="d-flex align-items-center w-100">
            <div class="col-8 text-gray d-grid gap-4 text-start">
              <span class="d-flex align-items-center gap-4">
                <h5 class="fw-bold">Phí vận chuyển</h5>
              </span>
            </div>
            <div class="col-4 gap-4">
              <h5>
                <span *ngIf="order.shipValue; else noShip">
                  {{ order.shipValue | currencySymbol }}
                </span>
                <ng-template #noShip> Không có </ng-template>
              </h5>
            </div>
          </div>
          <div class="d-flex align-items-center w-100">
            <div class="col-6 text-gray gap-4 text-start">
              <h5 class="fw-bold">Tổng cộng</h5>
            </div>
            <div class="col-6 gap-4">
              <h5 class="fs-5 fw-bold">
                {{ order.finalPrice | currencySymbol }}
              </h5>
            </div>
          </div>
          <!-- Nếu có giftExchange -->

          <ng-container
            *ngIf="order.orderStatus != cancelledOrderStatus && order.expectedReceivePoints && order.expectedReceivePoints.length > 0">
            <div class="d-flex align-items-center w-100">
              <div class="col-6 text-gray gap-4 text-start">
                <h5 *ngIf="order.orderStatus != 3" class="fw-bold">Số điểm dự kiến nhận được</h5>
                <h5 *ngIf="order.orderStatus == 3" class="fw-bold">Số điểm nhận được</h5>
              </div>
            </div>
            <div class="d-flex align-items-center w-100" *ngFor="let point of order.expectedReceivePoints">
              <div class="col-6 text-gray gap-4 text-start">
                <h5 class="fw-bold">{{ point }}</h5>
              </div>
              <div class="col-6 gap-4">
                <h5 class="fs-5 fw-bold theme-color">
                  {{ order.expectedReceivePoints[point] || 0 }}
                </h5>
              </div>
            </div>
          </ng-container>

          <!-- SAVE AS ORDER TEMPLATE SECTION -->
          <div class="save-order-template-wrapper mt-3 pt-3 border-top d-flex flex-column align-items-center text-center">
            <div class="template-prompt-text mb-2">Bạn thường xuyên đặt lại đơn hàng này?</div>
            <button
              type="button"
              class="btn-save-order-template"
              [disabled]="isSavingTemplate"
              (click)="saveAsOrderTemplate()"
              data-cta="order.save_template"
              data-cta-loc="order_detail"
            >
              <i class="ri-inbox-archive-line me-2 icon-box" *ngIf="!isSavingTemplate"></i>
              <span *ngIf="isSavingTemplate" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              <span>{{ isSavingTemplate ? 'Đang lưu...' : (isSavedTemplate ? 'Đã lưu thành đơn hàng thường xuyên' : 'Lưu thành đơn hàng thường xuyên') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <app-order-history-modal #orderHistoryModal  [order]="order"></app-order-history-modal>
</div>

<app-return-order-modal #returnOrderModal></app-return-order-modal>
<app-return-order-list-modal #returnOrderListModal></app-return-order-list-modal>
<app-shipment-list-modal #shipmentListModal></app-shipment-list-modal>
<app-order-shipping-modal #orderShippingModal></app-order-shipping-modal>
